import { createContext, useContext } from 'react'
import type { MideyeAuthContextValue } from '@mideye/auth-react'
import type { UserInfo } from '../types/api'

export type AuthContextType = MideyeAuthContextValue<UserInfo>

export const AuthContext = createContext<AuthContextType | undefined>(undefined)

export function useAuth(): AuthContextType {
  const context = useContext(AuthContext)
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider')
  }
  return context
}